import request from '@/utils/request';
// 基本信息
export const base = {
    archives_num: '', // 个案编号
    scoring_num: '', // scoring_num
    name: '', // 被评人姓名
    examiner_name: '', // 主试姓名
    gender: '', // 性别
    is_minorities: '', // 是否为少数名族
    hand_habit: '', // 用手习惯
    exam_address: '', // 测试地点
    born_time: '', // 出生日期
    real_age: '', // 实际年龄
    remark: '' // 备注说明
}

// 家长信息
export const parent = {
    edition: "1", // 幼儿版
    scoring_type: "1", // 家长
    grade: undefined, // 所在年级
    test_date: "", // 测试日期
    real_age: "", // 实际年龄
    parent_culture: undefined, // 家长文化
    score_communicate: "", // 沟通
    score_community: "", // 社区应用
    score_study: "", // 学前功能
    score_family: "", // 居家生活
    score_healthy: "", // 健康与安全
    score_leisure: "", // 休闲
    score_self_care: "", // 自我照顾
    score_self_guidance: "", // 自我管理
    score_social: "", // 社交
    score_skills: "", // 动作技巧
    confidence_probability: '95', // 置信区间
    significance_level: '0.05' // 显著性水平
}

// 教师信息
export const teacher = {
    edition: "1", // 幼儿版
    scoring_type: "2", // 教师
    grade: undefined, // 所在年级
    test_date: "", // 测试日期
    real_age: "", // 实际年龄
    parent_culture: undefined, // 家长文化
    score_communicate: "", // 沟通
    score_study: "", // 学前功能
    score_family: "", // 学校生活
    score_healthy: "", // 健康与安全
    score_leisure: "", // 休闲
    score_self_care: "", // 自我照顾
    score_self_guidance: "", // 自我管理
    score_social: "", // 社交
    score_skills: "", // 动作技巧
    confidence_probability: '95', // 置信区间
    significance_level: '0.05' // 显著性水平
}

// 家长验证
export const formRulesParent = {
    'parent.grade': [
        {required: true, message: '请选择所在年级', trigger: 'change'},
    ],
    'parent.test_date': [
        {required: true, message: '请选择测试日期', trigger: 'change'},
    ],
    'parent.real_age': [
        {required: true, message: '请计算实际年龄', trigger: 'change'},
    ],
    'parent.parent_culture': [
        {required: true, message: '请选择家长文化', trigger: 'change'},
    ],
    'parent.score_communicate': [
        {required: true, message: '请输入沟通分数', trigger: 'change'},
    ],
    'parent.score_community': [
        {required: true, message: '请输入社区应用分数', trigger: 'change'},
    ], 'parent.score_study': [
        {required: true, message: '请输入学前功能分数', trigger: 'change'},
    ],
    'parent.score_family': [
        {required: true, message: '请输入居家生活分数', trigger: 'change'},
    ],
    'parent.score_healthy': [
        {required: true, message: '请输入健康与安全分数', trigger: 'change'},
    ],
    'parent.score_leisure': [
        {required: true, message: '请输入休闲分数', trigger: 'change'},
    ],
    'parent.score_self_care': [
        {required: true, message: '请输入自我照顾分数', trigger: 'change'},
    ],
    'parent.score_self_guidance': [
        {required: true, message: '请输入自我管理分数', trigger: 'change'},
    ],
    'parent.score_social': [
        {required: true, message: '请输入社交分数', trigger: 'change'},
    ],
    'parent.score_skills': [
        {required: true, message: '请输入动作技巧分数', trigger: 'change'},
    ],
    'parent.confidence_probability': [
        {required: true, message: '请选择置信区间', trigger: 'change'},
    ],
    'parent.significance_level': [
        {required: true, message: '请选择统计显著性水平', trigger: 'change'},
    ]
}

// 教师验证
export const formRulesTeacher = {
    'teacher.grade': [
        {required: true, message: '请选择所在年级', trigger: 'change'},
    ],
    'teacher.test_date': [
        {required: true, message: '请选择测试日期', trigger: 'change'},
    ],
    'teacher.real_age': [
        {required: true, message: '请计算实际年龄', trigger: 'change'},
    ],
    'teacher.parent_culture': [
        {required: true, message: '请选择家长文化', trigger: 'change'},
    ],
    'teacher.score_communicate': [
        {required: true, message: '请输入沟通分数', trigger: 'change'},
    ],
    'teacher.score_community': [
        {required: true, message: '请输入社区应用分数', trigger: 'change'},
    ], 'teacher.score_study': [
        {required: true, message: '请输入学前功能分数', trigger: 'change'},
    ],
    'teacher.score_family': [
        {required: true, message: '请输入学校生活分数', trigger: 'change'},
    ],
    'teacher.score_healthy': [
        {required: true, message: '请输入健康与安全分数', trigger: 'change'},
    ],
    'teacher.score_leisure': [
        {required: true, message: '请输入休闲分数', trigger: 'change'},
    ],
    'teacher.score_self_care': [
        {required: true, message: '请输入自我照顾分数', trigger: 'change'},
    ],
    'teacher.score_self_guidance': [
        {required: true, message: '请输入自我管理分数', trigger: 'change'},
    ],
    'teacher.score_social': [
        {required: true, message: '请输入社交分数', trigger: 'change'},
    ],
    'teacher.score_skills': [
        {required: true, message: '请输入动作技巧分数', trigger: 'change'},
    ],
    'teacher.confidence_probability': [
        {required: true, message: '请选择置信区间', trigger: 'change'},
    ],
    'teacher.significance_level': [
        {required: true, message: '请选择统计显著性水平', trigger: 'change'},
    ]
}
